// extracted by mini-css-extract-plugin
export var desktop = "layout-module--desktop--45547";
export var experience = "layout-module--experience--4313b";
export var hide = "layout-module--hide--7a8a5";
export var main = "layout-module--main--3f0fd";
export var menu = "layout-module--menu--a7ed2";
export var mobile = "layout-module--mobile--a2d15";
export var visible = "layout-module--visible--195a2";
export var wrapper = "layout-module--wrapper--f9f57";